/*
 * Copyright © 2019 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import TSAnlaufstelle from '../models/TSAnlaufstelle';

export default class AnlaufstelleUtil {
    public static IMPORTIERTE_ANLAUFSTELLE_ID = 'c856122f-4d20-bbbb-cccc-fcc5e7831614';
    public static isNotImportiert(anlaufstelle: TSAnlaufstelle): boolean {
        return anlaufstelle.id !== AnlaufstelleUtil.IMPORTIERTE_ANLAUFSTELLE_ID;
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/AnlaufstelleUtil.ts